










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue'
import { MenuItem } from "../../NewConfig";

@Component({
  components: {
    Icon
  }
})
export default class SidebarIcon extends Vue {
  @Prop() icon!:MenuItem['icon']
}
